export default __webpack_public_path__ + "static/media/mc_rae_phone.e3a219b7.mp4";